import { useTranslation } from '../../hooks/useTranslation';
import Header from '../../components/feature/Header';

const HomePage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-heart-pulse-line',
      title: t('features.health.title'),
      description: t('features.health.desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('features.safety.title'),
      description: t('features.safety.desc'),
    },
    {
      icon: 'ri-health-book-line',
      title: t('features.hygiene.title'),
      description: t('features.hygiene.desc'),
    },
    {
      icon: 'ri-user-search-line',
      title: t('features.analysis.title'),
      description: t('features.analysis.desc'),
    },
    {
      icon: 'ri-alarm-warning-line',
      title: t('features.warning.title'),
      description: t('features.warning.desc'),
    },
    {
      icon: 'ri-file-chart-line',
      title: t('features.reporting.title'),
      description: t('features.reporting.desc'),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-white dark:bg-gray-900 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/a19a693f94bb8696fb35e691611afd2c.jpg"
            alt="Workplace Health Monitoring"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-white/90 dark:bg-gray-900/90"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6 leading-tight">
              {t('home.hero.title')}
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
              {t('home.hero.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/login"
                className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                {t('home.hero.login')}
              </a>
              <a
                href="/register"
                className="border-2 border-primary-600 text-primary-600 dark:text-primary-400 hover:bg-primary-50 dark:hover:bg-primary-900/20 px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                {t('home.hero.register')}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              {t('home.features.title')}
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              {t('home.features.subtitle')}
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white dark:bg-gray-700 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-12 h-12 bg-primary-100 dark:bg-primary-800 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-primary-600 dark:text-primary-400 text-xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 dark:bg-gray-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">OccuHealthPro</h3>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
              {t('footer.company')}
            </p>
            <div className="border-t border-gray-700 pt-6">
              <p className="text-gray-400 text-sm">
                © 2025 OccuHealthPro. {t('footer.rights')}{' '}
                <a 
                  href="/" 
                  className="text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  Powered by Cemal Üresin
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
